export default {
  title: '我的奖励',
  menu: '奖励',
  label: {
    myRewards: '我的奖励',
    myReferrals: '我的推荐',
    redeemHistory: '兑换历史',
    getRewards: '获取奖励',
    weChatQrCodeTip: '微信扫描二维码，绑定账号',
    payByWeChatWallet: '绑定微信钱包',
    rewards: '奖励'
  },
  message: {
    noReferrals: '啊！你还没有赚到任何推荐奖励，立刻到职位列表查看有推荐奖励的职位参与进来吧！',
    noRedeemHistory: '啊！你还没有任何兑换记录，立刻到职位列表查看有推荐奖励的职位参与进来吧！',
    redeemInProcess: '兑换中，请稍后',
    redeemHasError: '兑换错误。请尝试重试或者电话客服热线 400-990-3308',
    redeemSuccess: '兑换成功！',
    copyRedeemCodeOrClose: '复制去京东兑换',
    copyRedeemCode: '复制去京东兑换',
    copySuccess: '复制成功',
    copyFail: '复制失败，请尝试长按复制',
    copyWithCtrlC: '请按CTRL+C复制'
  },
  rewardsUnit: {
    cash: '元',
    jdEPoints: '京东E卡',
    points: '积分'
  },
  referralStep: {
    applied: '申请奖励',
    interviewed: '面试奖励',
    onboard: '入职奖励',
    probation: '试用期奖励'
  },
  goods: {
    JD_E_CARD: '京东E卡'
  },
  btn: {
    myReferrals: '我的推荐',
    redeemHistory: '兑换历史',
    redeemPoints: '兑换 {points}',
    viewJDECode: '查看京东E卡'
  },
  custom: {
    starbucks: {
      title: '我的推荐奖励',
      listHead: '详细记录',
      stepName: {
        applied: '已申请',
        interviewed: '参加面试',
        onboard: '入职报到',
        probation: '通过试用期'
      },
      listColumnName: {
        applicantName: '姓名',
        jobName: '职位',
        stepName: '状态',
        date: '日期'
      },
      viewPolicyBtn: '查看推荐奖励政策',
      referralRewardsPolicy: '星巴克推荐奖励政策'
    },
    elc: {
      tipMessage: '请联系人事部门了解具体奖励信息'
    }
  }
}
